import { gql, useQuery } from '@apollo/client'

const GET_GROUP_EVENT_TEMPLATES = gql`
  query GetGroupEventTemplates {
    groupEventTemplates {
      id
      slug
      academyRequired
      title
      caption
      tags
      description
      featuredImageUrl
      isNew
    }
  }
`

const useGroupEventTemplateOptions = () => {
  const { data = {}, loading, error } = useQuery(GET_GROUP_EVENT_TEMPLATES, {
    fetchPolicy: 'cache-first',
  })
  const { groupEventTemplates = [] } = data

  return {
    groupEventTemplates,
    loading,
    error,
  }
}

const GET_GROUP_EVENT_TAGS = gql`
  query GetGroupEventTags {
    groupEventTags
  }
`

const useGroupEventTagOptions = () => {
  const { data = {} } = useQuery(GET_GROUP_EVENT_TAGS)
  const { groupEventTags = [] } = data
  return groupEventTags
}

export {
  GET_GROUP_EVENT_TEMPLATES,
  useGroupEventTemplateOptions,
  useGroupEventTagOptions,
}
